import { zSchema } from "@zeal/common";

export const updateCheckbookUsersFirstAndLastNamesRequestSchema =
  zSchema.object({
    testMode: zSchema.boolean(),
    users: zSchema.array(
      zSchema.object({
        odo_user_id: zSchema.string(),
        first_name: zSchema.string(),
        last_name: zSchema.string(),
      })
    ),
  });

export const updateCheckbookUsersFirstAndLastNamesResponseSchema =
  zSchema.object({
    failed_users: zSchema.array(zSchema.string()),
    skipped_users: zSchema.array(zSchema.string()),
    success: zSchema.boolean(),
  });

export type TUpdateCheckbookUsersFirstAndLastNamesRequestSchema = zSchema.input<
  typeof updateCheckbookUsersFirstAndLastNamesRequestSchema
>;

export type TUpdateCheckbookUsersFirstAndLastNamesResponseSchema =
  zSchema.output<typeof updateCheckbookUsersFirstAndLastNamesResponseSchema>;
